// extracted by mini-css-extract-plugin
module.exports = {"cricSpecial":"style_cricSpecial__T2CNr","postimg":"style_postimg__j4iha","icon":"style_icon__E6QQg"};